import { useEffect, useRef } from 'react';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // The effect depends on the current value

  return ref.current;
}

export default usePrevious;
